import { LowerCasePipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { PropertyAttributeComponent } from '@rma/public/campaigns/public/ui-campaign-attribute';
import { ListingImageType } from '@rma/public/generic/domain/types';
import { provideRmaCarousel, RmaCarouselComponent, RmaCarouselItemSource } from '@rma/public/generic/ui/carousel';
import { SeeMoreTextComponent } from '@rma/public/generic/ui/see-more-text';
import { TrixelComponent } from '@rma/public/generic/ui/trixels';
import { TimeAgoPipe } from '@rma/public/generic/util/pipes/date';
import { StarRatingComponent } from '@rma/public/reviews/public/ui-rating';
import { MarketReportReview } from '../../domain';

@Component({
  selector: 'rma-market-report-review-tile',
  templateUrl: './market-report-review-tile.component.html',
  styleUrls: ['./market-report-review-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LowerCasePipe,
    NgTemplateOutlet,
    PropertyAttributeComponent,
    RmaCarouselComponent,
    SeeMoreTextComponent,
    StarRatingComponent,
    TimeAgoPipe,
    TranslocoPipe,
    TrixelComponent,
  ],
  providers: [provideRmaCarousel()],
})
export class MarketReportReviewTileComponent implements OnChanges {
  @Input()
  review: MarketReportReview | null | undefined;

  @Input()
  isReportOwner: boolean;

  @Input()
  isPrintMode: boolean | null = false;

  @HostBinding('class.bg-blue-10')
  @HostBinding('class.rounded')
  @Input()
  selected = false;

  reviewerTypeKey = '';

  images: RmaCarouselItemSource[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    const { review } = changes;

    if (review && this.review?.reviewerType) {
      this.reviewerTypeKey = `reviewer-type.${this.review.reviewerType.toLocaleLowerCase().replace(' ', '-')}`;
      this.images = this.review ? this.getImages(this.review) : [];
    }
  }

  private getImages(review: MarketReportReview): RmaCarouselItemSource[] {
    const alt = review.streetAddress;

    if (review.propertyImages) {
      return [
        ...review.propertyImages.filter((x) => x.imageType === ListingImageType.Hero),
        ...review.propertyImages.filter((x) => x.imageType !== ListingImageType.Hero),
      ].map((x) => ({ src: x.imageUrl, alt }));
    }

    if (review.propertyCoverImage) {
      return [{ src: review.propertyCoverImage, alt }];
    }

    return [];
  }
}
